export const PERSONAS = [
  'internal_teacher',
  'external_teacher',
  'current_student',
  'graduated_student',
  'visitor',
  'admin',
] as const;

export type PortalPersona = (typeof PERSONAS)[number];

export const PERSONA_LABEL: Record<PortalPersona, string> = {
  admin: '管理员',
  internal_teacher: '组内教师',
  external_teacher: '组外教师',
  current_student: '在读学生',
  graduated_student: '毕业学生',
  visitor: '访客',
};

const PERSONA_RANK: Record<PortalPersona, number> = {
  visitor: 0,
  external_teacher: 1,
  graduated_student: 2,
  current_student: 3,
  internal_teacher: 5,
  admin: 5,
};

export function personaRank(persona: PortalPersona): number {
  return PERSONA_RANK[persona] ?? 0;
}

export function isManager(persona: PortalPersona): boolean {
  return persona === 'admin' || persona === 'internal_teacher';
}

export function canViewInternal(persona: PortalPersona): boolean {
  return isManager(persona) || persona === 'current_student' || persona === 'graduated_student';
}

export function canEditResume(persona: PortalPersona): boolean {
  return isManager(persona) || persona === 'current_student';
}

export function canPresent(persona: PortalPersona): boolean {
  return isManager(persona);
}